module.exports = __webpack_public_path__ + "static/contact-84182f599ab96e0de0a16227ad5f9668.png";